import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import voivodeshipReducer from "../slices/voivodeship/voivodeshipSlice"
import companyReducer from "../slices/company/companySlice"
import userReducer from "../slices/user/userSlice"
import authReducer from "../slices/auth/authSlice"
import billsReducer from "../slices/bill/billSlice";
import adminUsersReducer from "../slices/adminUser/adminUserSlice";
import adminOffersReducer from "../slices/adminOffer/adminOfferSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    voivodeship: voivodeshipReducer,
    companies: companyReducer,
    user: userReducer,
    auth: authReducer,
    bills: billsReducer,
    adminUser: adminUsersReducer,
    adminOffer: adminOffersReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
